import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import Intro from "@/pages/home/components/Intro";
import Catalog from "@/pages/home/components/Catalog";
import LessonExplorer from "@/pages/home/components/LessonExplorer";
import VideoResources from "@/pages/home/components/VideoResources";
import LearningPath from "@/pages/home/components/LearningPath";
import Highlights from "@/pages/home/components/Highlights";
import Faq from "@/pages/home/components/Faq";
import Guide from "@/pages/home/components/Guide";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Intro />
        <Catalog />
        <LessonExplorer />
        <VideoResources />
        <LearningPath />
        <Highlights />
        <Faq />
        <Guide />
      </main>
      <Footer />
    </div>
  );
}